module.exports = "/_next/static/images/Trend04Visual-2c7eb351bfc763ec94cc10160963fd9b.png";